// @ts-ignore
import { Circle, Fill, Icon, Stroke, Style } from "ol/style";

export class OlMapStyles {
  public static STYLES = {
    route: [
      new Style({
        stroke: new Stroke({
          color: "rgba(0,42,255,0.5)",
          width: 6
        })
      }),
      new Style({
        stroke: new Stroke({
          color: "rgba(70,134,255,0.5)",
          width: 4
        })
      })
    ],
    job: new Style({
      image:
        //   new Icon(
        //   {
        //   anchor: [0.5, 1],
        //   color: 'rgb(78,14,119)',
        //   src: 'assets/markers/job1.svg'
        // }
        // )
        new Circle({
          radius: 10,
          fill: new Fill({ color: "rgba(255, 0, 0, 0.1)" }),
          stroke: new Stroke({ color: "red", width: 1 })
        })
    }),
    home: new Style({
      image: new Icon({
        anchor: [0.5, 1],
        color: "rgb(78,14,119)",
        src: "assets/markers/job1.svg"
      })
    })
  };
  public static HIGHLIGHT_STYLES = {
    route: [
      new Style({
        stroke: new Stroke({
          color: "rgba(0,42,255,1)",
          width: 8
        })
      }),
      new Style({
        stroke: new Stroke({
          color: "rgba(70,134,255,1)",
          width: 6
        })
      })
    ],
    job: new Style({
      image: new Circle({
        radius: 12,
        fill: new Fill({ color: "rgba(255, 0, 0, 0.1)" }),
        stroke: new Stroke({ color: "red", width: 1 })
      })
    }),
    home: new Style({
      image: new Icon({
        anchor: [0.5, 1],
        color: "rgb(78,14,119)",
        src: "assets/markers/job1.svg"
      })
    })
  };
}
